// LazyLoad - https://github.com/aFarkas/lazysizes
import 'lazysizes'
// import a plugin
import 'lazysizes/plugins/parent-fit/ls.parent-fit'

// Theme Functions
const fSmoothScroll = require('./utils/smooth-scroll')
import observeAndExecute from './utils/observe-and-execute';
const fCarousels = require('./components/carousels');
const fSelect = require('./components/select');
// const fGsapController = require('./components/gsap-controller')
import VueComponents from "./components/vue-components";
const fMobileMenu = require('./components/mobile-menu');
const fHeader = require('./components/header');
const fNavigationAccordion = require('./components/navigation-accordion');

fHeader.init()
fMobileMenu.init()

new VueComponents({
    components: [
        {name: 'post-lists', file: () => import('./vue/post-lists.vue')},
        {name: 'nominees-list', file: () => import('./vue/nominees-list.vue')},
        {name: 'events-list', file: () => import('./vue/events-list.vue')},
        {name: 'current-nominees-list', file: () => import('./vue/current-nominees-list.vue')},
    ],
});
document.addEventListener("DOMContentLoaded", () => {
    fNavigationAccordion();
    fSmoothScroll()
    fSelect.init()

    observeAndExecute(".swiper", {
        callback: () => fCarousels.init(),
        disconnect: true,
    })

    observeAndExecute(".video-inline", {
        callback: (el) => {
            const video = el.querySelector("video");
            if (!video) return;

            const setVideoSource = () => {
                const isMobile = window.innerWidth < 768;
                const newSrc = isMobile ? video.dataset.srcMobile : video.dataset.srcDesktop;

                if (video.src !== newSrc) {
                    video.setAttribute("src", newSrc);
                    video.load();
                    video.play().catch(() => {}); // prevent autoplay errors
                }
            };

            const handlePlay = () => {
                el.querySelector(".video-inline-poster")?.remove();
                video.removeEventListener("play", handlePlay);
            };

            video.addEventListener("play", handlePlay);

            // initial set
            setVideoSource();

            // recheck on resize
            window.addEventListener("resize", setVideoSource);
        }
    });

    if (document.querySelector(".accordion-list")) {
        const loadAccordion = async () => {
            const fAccordionList = await import('./components/accordion-list');
            fAccordionList.init();
        }

        loadAccordion();

        // Debounce utility (waits for resizing to finish)
        function debounce(func, wait = 200) {
            let timeout;
            return () => {
                clearTimeout(timeout);
                timeout = setTimeout(func, wait);
            };
        }

        // Re-init accordion on resize
        window.addEventListener("resize", debounce(loadAccordion, 200));
    }

    const forms = document.querySelectorAll('.search-form');

    forms.forEach(form => {
        const input = form.querySelector('.searchbar');
        const button = form.querySelector('button[type="submit"]');

        function toggleButton() {
            if (input.value.trim().length >= 3) {
                button.disabled = false;
            } else {
                button.disabled = true;
            }
        }

        // Initial check
        toggleButton();

        // Listen for input changes
        input.addEventListener('input', toggleButton);
    });


    const form = document.querySelector(".contact-form");

    if (form) {
        console.log(form)
        const select = form.querySelector("select");
        const hiddenField = form.querySelector(".mail-response input");

        if (select && hiddenField && Array.isArray(mailAnswers)) {
            select.addEventListener("change", function () {
                const index = this.selectedIndex ; // first option = blank
                let htmlContent = "";
               

                if (index >= 0 && mailAnswers[index]) {
                    htmlContent = mailAnswers[index].content;
                }
                console.log(htmlContent)

                hiddenField.value = htmlContent; // CF7 will submit this as raw HTML
            });
        }
    }
    
   
});